export const en = {
    addMoney: 'Top up',
    moneyBlocked: 'Funds blocked',
    needPayment: 'Campaign funds have expired. You need to top up your balance.'
};
